import { render } from "./page-webinars-section.vue?vue&type=template&id=bf216b74&scoped=true"
import script from "./page-webinars-section.vue?vue&type=script&lang=js"
export * from "./page-webinars-section.vue?vue&type=script&lang=js"

import "./page-webinars-section.vue?vue&type=style&index=0&id=bf216b74&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf216b74"],['__file',"src/components/notepad/pages/page-webinars-section.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf216b74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf216b74', __exports__)) {
    api.reload('bf216b74', __exports__)
  }
  
  module.hot.accept("./page-webinars-section.vue?vue&type=template&id=bf216b74&scoped=true", () => {
    api.rerender('bf216b74', render)
  })

}


export default __exports__